import { render, staticRenderFns } from "./calc.vue?vue&type=template&id=25118fba&"
import script from "./calc.vue?vue&type=script&lang=js&"
export * from "./calc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BetbuilderResults: require('/var/web/bet777.es/components/betbuilder/results.vue').default,BetbuilderLine: require('/var/web/bet777.es/components/betbuilder/line.vue').default,UiBetbuilderEmpty: require('/var/web/bet777.es/themes/dark/ui/Betbuilder/Empty.vue').default,UiBetslipFreeBet: require('/var/web/bet777.es/themes/dark/ui/Betslip/FreeBet.vue').default,BetslipMoney: require('/var/web/bet777.es/components/betslip/money.vue').default,UiBetbuilderBetType: require('/var/web/bet777.es/themes/dark/ui/Betbuilder/BetType.vue').default,UiBetbuilderButton: require('/var/web/bet777.es/themes/dark/ui/Betbuilder/Button.vue').default,UiBetslipWrapper: require('/var/web/bet777.es/themes/dark/ui/Betslip/Wrapper.vue').default})
